import { request } from '@/utils/request'
import axios, { type AxiosError, type AxiosRequestConfig, type AxiosResponse } from 'axios'
import { BASE_URL, FILE_URL } from '@/config'

export async function recommendedVideo(params?: any,data?:any) {

    const { start, pageSize } = params
    const res = await request({ url: '/?_Action=short&_Method=collection', method: 'get', params, data })
    const rr = {
        data: {
          total: res.data.total,
          list: res.data.data.slice(start, start + pageSize)
        }
    }
    return rr

}
